import { render } from "./CatalogueForm.vue?vue&type=template&id=d8396a84"
import script from "./CatalogueForm.vue?vue&type=script&lang=js"
export * from "./CatalogueForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__